/**
 * "Facebook didn't take this post at 9:53 PM: the connection timed out.
 * Nothing was posted. “Game 4 tonight…”" — the Reach calendar's words, plus
 * the post's opening so a Today card says which one.
 */
export function missedNote(
  channel: string,
  at: Date | null,
  failure: string | null | undefined,
  text: string,
  now = new Date()
) {
  const clock = (d: Date) => d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
  const day = (d: Date) => d.toLocaleDateString([], { weekday: 'short' });
  const whenText = at
    ? at.toDateString() === now.toDateString()
      ? ` at ${clock(at)}`
      : ` on ${day(at)} at ${clock(at)}`
    : '';
  const excerpt = text.length > 80 ? `${text.slice(0, 80).trimEnd()}…` : text;
  return (
    `${channel} didn’t take this post${whenText}${failure ? `: ${failure}` : ''}. Nothing was posted.` +
    (excerpt ? ` “${excerpt}”` : '')
  );
}
